import { useFeatureFlags } from 'utils/features';

export default function useSafetyOverviewEnabled() {
  return useFeatureFlags('SAFETY_OVERVIEW');
}
